// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1zcSh","clinicsSelect":"TableHeading_clinicsSelect__2GaN-"};